import { render, staticRenderFns } from "./vuepdf.vue?vue&type=template&id=63b439d2&scoped=true&"
import script from "./vuepdf.vue?vue&type=script&lang=js&"
export * from "./vuepdf.vue?vue&type=script&lang=js&"
import style0 from "./vuepdf.vue?vue&type=style&index=0&id=63b439d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b439d2",
  null
  
)

export default component.exports